module.exports = __webpack_public_path__ + "7334681d75049d3ee548873112a42ebd.fbx";